import Icon from '../components/Icon.vue'

Icon.register({
  key: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M512 176C512 273.2 433.2 352 336 352 324.8 352 313.8 350.9 303.2 348.9L279.2 375.9A24-24 0 0 0 261.2 384H224V424C224 437.3 213.3 448 200 448H160V488C160 501.3 149.3 512 136 512H24C10.7 512 0 501.3 0 488V409.9C0 403.6 2.5 397.5 7 393L168.8 231.2C163.1 213.8 160 195.3 160 176 160 78.8 238.8 0 336 0 433.5 0 512 78.5 512 176zM336 128C336 154.5 357.5 176 384 176S432 154.5 432 128 410.5 80 384 80 336 101.5 336 128z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/key.js
// module id = aJB3
// module chunks = 144